<template>
    <be-form-group v-bind="widgetProps">
        <be-loading :active="!options">
            <select
                ref="el"
                :class="widgetClass"
                :id="name"
                :name="name"
                :required="required"
                :multiple="multiple"
                :disabled="disabled"
                :value="value"
                @input="$emit('input', $event.target.value)"
                @change="$emit('change', $event.target.value)"
            >
                <option value="" v-if="!options">Lade Optionen …</option>
                <option
                    v-for="option in options"
                    :key="option.value"
                    :value="option.value"
                    v-else
                >{{ option.label }}
                </option>
            </select>
        </be-loading>
    </be-form-group>
</template>

<script>
    import widget from '../../mixins/widget';

    export default {
        mixins: [widget],

        props: {
            options: Array,
            multiple: Boolean,
        },

        mounted() {
            this.$nextTick(() => {
                if (this.$refs.el) {
                    this.$emit('input', this.$refs.el.value);
                }
            });
        },

        updated() {
            if (this.$refs.el) {
                this.$emit('input', this.$refs.el.value);
            }
        },
    };
</script>
